import { render, staticRenderFns } from "./block-claim-type.vue?vue&type=template&id=5d5b1524&scoped=true&"
import script from "./block-claim-type.vue?vue&type=script&lang=js&"
export * from "./block-claim-type.vue?vue&type=script&lang=js&"
import style0 from "./block-claim-type.vue?vue&type=style&index=0&id=5d5b1524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5b1524",
  null
  
)

export default component.exports